import Vue from 'vue'
import store from '~/store'
import router from '~/router'
import i18n from '~/plugins/i18n'
import App from '~/components/App'

import '~/plugins'
import '~/components'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'

// color picker
import InputColorPicker from 'vue-native-color-picker'

import axios from 'axios'
import Cookies from 'js-cookie'

// custom alerts

// component imports for mixin calls
// import email from '~/pages/modules/email/index.vue'
// import tour from '~/pages/modules/modals/tour.vue'
// import survey from '~/pages/modules/modals/survey.vue'
import notes from '~/pages/modules/notes/index.vue'
import video from '~/pages/modules/modals/video.vue'

import './bootstrap'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import JsonEditor from 'vue-json-edit'
import { VueCsvImport } from 'vue-csv-import'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
import FileManager from 'laravel-file-manager'

axios.interceptors.response.use(
  response => {
    return response;
  },
  function (error) {
    // if(error.response.status === 401) {
    //   // redirect to login page
    //   window.location.href = "/login";
    // }
    return Promise.reject(error.response.data);
  }
);

Vue.use(VueMaterial)

Vue.use(BootstrapVue)

Vue.use(InputColorPicker)

// json editor
Vue.use(JsonEditor)

Vue.use(VueJsonPretty)

Vue.use(VueCsvImport)

// Cirt Requirements
import { BVModalPlugin } from "bootstrap-vue";
import VTooltip from "v-tooltip";
import Toasted from "vue-toasted";
import VueTour from "vue-tour";
import vueAwesomeCountdown from "vue-awesome-countdown";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "vue-context/dist/css/vue-context.css";
import "vue-tour/dist/vue-tour.css";

Vue.use(BVModalPlugin);
Vue.use(IconsPlugin)
Vue.use(VTooltip);
Vue.use(VueTour);
Vue.use(Toasted, {
  position: "bottom-center",
  fullWidth: true,
  theme: "bubble",
  duration: 5000
});
Vue.use(vueAwesomeCountdown, "vac");

Vue.use(FileManager, {store})
// end of Phase 2 additions

Vue.config.productionTip = false

/*
 * the mixins are accessible to the whole vue application so any method that should be available to any component
 * should be put here.
 *
 * to call a mixin just call "this.<mixin_function>"
 */

Vue.mixin({
  methods: {
    /* 
     * THIS process_event IS OLD THE NEW FUNCTION IS IN resources/js/store/modules/events.js
     * 
     * 
     * bool process_event(string eventId, string moduleContent)
     * returns true if event is processed
     * returns false if there is an error
     * module content is optional and should be JSON format.
     * This is called when an event needs to be processed. pass in the eventId of the event that is being processed
     * if there is module content pass that in as a JSON string.
     * This will make a request to the back end and call the call_module_event() method based on the response
     *
     *
     *
     
    process_event: async function(eventId, moduleContent) {
      try {
        console.log("Bad process event", eventId)
        let pcs_id = localStorage.getItem('pcs')
        let role_id = 0
        if (moduleContent !== undefined) {
          if (moduleContent.hasOwnProperty('pcs_id')) {
            pcs_id = moduleContent.pcs_id
          }
          if (moduleContent.hasOwnProperty('class_id')) {
            let role_response = await axios.post('/api/get_role_by_class', {
              params: {
                class_id: moduleContent.class_id
              }
            })
            role_id = role_response.data
            moduleContent = moduleContent.class_id
          }
        }
         console.log({
          eid: eventId,
          pcs_id: pcs_id,
          content: moduleContent,
          role_id: role_id,
        }) 
        let response = await axios.post('/api/processEvent', {
          params: {
            eid: eventId,
            pcs_id: pcs_id,
            content: (moduleContent !== undefined) ? moduleContent : '',
            role_id: role_id,
          },
        })
        for (let i in response.data) {
          let events = response.data[i]
          for (let j in events) {
            if (!events[j].role || (this.$store.state.group.role && events[j].role === this.$store.state.group.role.role_id)) {
              this.call_module_method(events[j].module, events[j].action, events[j].content)
            }
            // if (!events[j].role || events[j].role === this.$store.state.roles.role.role_id) {
            // this.call_module_method(events[j])
            // }
          }
        }
        return true
      } catch (err) {
        console.log('Failed')
        console.log(err)
        return false
      }
    },
    /*
     * the method is called by process_event above.
     * the module action and content params will be included from the response from process_event
     *
     * this function is a handler and calls handlers on the component vue.
     * to use this add a case to the switch statement based on the component that will handle the response and import
     * that component so it can be called.
     *
     
    call_module_method: function(module, action, content) {
      switch (module) {
        case 'email':
          this.$store.dispatch(action, content)
          break
        case 'tour':
          this.$store.dispatch(action, content)
          break
        case 'notes':
          notes.methods.showHiddenTab.call(this, action)
          break
        case 'survey':
          this.$store.dispatch(action, content)
          break
        case 'video':
          this.$store.dispatch(action, content)
          break
        case 'chat':
          this.$store.dispatch(action, content)
          break
        case 'gameboard':
          this.$store.dispatch(action, content)
          break
        default:
          this.$store.dispatch(action, content)
      }
    },
    */
    scrollTo: function (id) {
      let tag = '#' + id
      document.querySelector(tag).scrollIntoView({ behavior: 'smooth' })
    },
  },
})

/* eslint-disable no-new */
new Vue({
  components: { VueCsvImport, VueJsonPretty },
  i18n,
  store,
  router,
  ...App,
})
